// Utility to manage Google Analytics and Google Tag Manager

export const initializeAnalytics = (analyticsEnabled, gtmEnabled) => {
  if (analyticsEnabled) {
    enableGoogleAnalytics();
  } else {
    disableGoogleAnalytics();
  }

  if (gtmEnabled) {
    enableGoogleTagManager();
  } else {
    disableGoogleTagManager();
  }
};

export const enableGoogleAnalytics = () => {
  // Check if GA is already loaded
  if (window.gtag) {
    window.gtag('consent', 'update', {
      analytics_storage: 'granted'
    });
  }
};

export const disableGoogleAnalytics = () => {
  // Disable GA tracking
  if (window.gtag) {
    window.gtag('consent', 'update', {
      analytics_storage: 'denied'
    });
  }

  // Delete GA cookies
  deleteGACookies();
};

export const enableGoogleTagManager = () => {
  // GTM is loaded in index.html, just ensure dataLayer is available
  if (!window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
  }
};

export const disableGoogleTagManager = () => {
  // Disable GTM by clearing dataLayer events
  if (window.dataLayer) {
    window['ga-disable-GTM-5KGWXMFT'] = true;
  }
};

const deleteGACookies = () => {
  // Delete Google Analytics cookies
  const gaCookies = ['_ga', '_gat', '_gid'];
  gaCookies.forEach(cookie => {
    document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
    document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
  });
};

export const clearAllAnalyticsCookies = () => {
  deleteGACookies();
  
  // Clear localStorage items related to analytics if any
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.includes('_ga') || key.includes('gtm'))) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
};
